import { program } from 'commander';
import { readFileSync } from 'fs';
import { join } from 'path';
import pc from 'picocolors';
import { initCommand } from './commands/init';
import { configCommand } from './commands/config';
import { simpleInitCommand } from './commands/simple-init';
import { handleError } from './utils/errors';

// Read package.json for version
const packageJsonPath = join(
  __dirname.includes('dist') 
    ? join(__dirname, '../package.json')
    : join(__dirname, '../../package.json')
);
const packageJson = JSON.parse(readFileSync(packageJsonPath, 'utf-8'));

// Set up the main program
program
  .name('vibeship')
  .description('CLI for Vibeship DevTools - Transform your markdown into an intelligent project assistant')
  .version(packageJson.version)
  .option('-v, --verbose', 'enable verbose logging')
  .option('--no-color', 'disable colored output')
  .configureOutput({
    outputError: (str, write) => write(pc.red(str)),
  });

// Add commands
program.addCommand(simpleInitCommand); // New simplified init as default
program.addCommand(initCommand.name('init-advanced').description('Advanced initialization (legacy)')); 
program.addCommand(configCommand);

// Custom help
program.on('--help', () => {
  console.log('');
  console.log('Examples:');
  console.log('  $ vibeship init                   # Quick setup (recommended)');
  console.log('  $ vibeship init --level standard  # Standard setup with all features');
  console.log('  $ vibeship init --level advanced  # Full control over setup');
  console.log('  $ vibeship config --list          # List current configuration');
  console.log('  $ vibeship config set scanPaths "./docs,./src"');
  console.log('');
  console.log('For more information, visit: https://vibeship.dev/docs');
});

// Error handling
process.on('SIGINT', () => {
  console.log(pc.yellow('\n\nOperation cancelled by user'));
  process.exit(130); // 128 + 2 (SIGINT)
});

process.on('SIGTERM', () => {
  process.exit(143); // 128 + 15 (SIGTERM)
});

// Export the program for use in index.ts
export { program };

// Parse arguments only if this is the main module
if (require.main === module) {
  program.parse(process.argv);
  
  // Show help if no command provided
  if (!process.argv.slice(2).length) {
    program.outputHelp();
  }
}